module.exports = "/_next/static/images/BlockDataCollection@2x-e0c8693c4286e56fe3c9af83545ec744.png";